import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../utils/useService';
import { QUESTION_BANK_ENVIRONMENT } from '../../utils/constants';

const useCreate = () => {
	// const emptyCsvObject = { oldCsv: '', newCsv: '' };
	const [showLoader, setShowLoader] = useState(false);
	// const [isDiffClose, setIsDiffClose] = useState(true);
	// const [diffFormState, setDiffFormState] = useState(true);
	const [uploadFormState, setUploadFormState] = useState(false);
	const [statusFormState, setStatusFormState] = useState(false);
	const [statusLogs, setStatusLogsState] = useState('');
	// const [csvDiffValue, setCsvDiffValue] = useState(emptyCsvObject);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	// const { requestCreateQuestionBank, requestCsvDiff, getQuestionBankCsvStatus } = useService();
	const { requestCreateQuestionBank, getQuestionBankCsvStatus } = useService();

	const createQuestionBank = (createdData: any) => {
		setShowLoader(true);
		// const questionBankLogKey: string = `questionBankDevLog-${createdData.gameName}`;
		// const questionBankDevLogFromLocal: string | null = window.localStorage.getItem(questionBankLogKey);
		// const questionBankDevLog = questionBankDevLogFromLocal ? JSON.parse(questionBankDevLogFromLocal as string) : {};
		if (
			createdData.environment === QUESTION_BANK_ENVIRONMENT.STAGING ||
			// (createdData.environment === QUESTION_BANK_ENVIRONMENT.PROD) && questionBankDevLog?.status === 'SUCCESS')
			createdData.environment === QUESTION_BANK_ENVIRONMENT.PROD
		) {
			const appName: string = createdData.gameName === 'zcm' ? 'com.zupee.free' : app.appName;
			requestCreateQuestionBank(appName, { ...createdData }).then(
				(res: any) => {
					if (res?.status !== 200 || !res?.data?.success) {
						showAlert(res?.data?.error || 'Error occured while creating question bank', { type: 'error' });
					} else {
						showAlert('QuestionBank csv uploaded successfully');
						// window.localStorage.setItem(questionBankLogKey, JSON.stringify(res?.data?.data?.data));
					}
					setShowLoader(false);
				},
				(err: any) => {
					showAlert(`Error: ${err}`, { type: 'error' });
					setShowLoader(false);
				}
			);
			// } else if (questionBankDevLog?.status !== 'SUCCESS' && questionBankDevLog.docId) {
			// 	showAlert('Checking status, Please wait!');
			// 	getQuestionBankCsvStatus(
			// 		{ app },
			// 		{ docId: questionBankDevLog.docId, environment: QUESTION_BANK_ENVIRONMENT.STAGING }
			// 	).then(
			// 		(res: any) => {
			// 			if (res?.status !== 200 || !res?.data?.success) {
			// 				showAlert(res?.data?.error || 'Error while checking dev questionBank status', { type: 'error' });
			// 				setShowLoader(false);
			// 			} else {
			// 				const resp = res?.data?.data;
			// 				window.localStorage.setItem(questionBankLogKey, JSON.stringify({ status: resp.status, docId: resp.docId }));
			// 				if (resp.status === 'SUCCESS') {
			// 					showAlert('Dev test passed, uploading on production, please wait');
			// 					requestCreateQuestionBank(app.appName, { ...createdData }).then(
			// 						(response: any) => {
			// 							if (response?.status !== 200 || !response?.data?.success) {
			// 								showAlert(response?.data?.error || 'Error occured while creating question bank', {
			// 									type: 'error'
			// 								});
			// 							} else {
			// 								showAlert('QuestionBank csv uploaded successfully');
			// 								window.localStorage.removeItem(questionBankLogKey);
			// 								history.goBack();
			// 							}
			// 							setShowLoader(false);
			// 						},
			// 						(err: any) => {
			// 							showAlert(`Error: ${err}`, { type: 'error' });
			// 							setShowLoader(false);
			// 						}
			// 					);
			// 				} else {
			// 					showAlert(`Dev test status: ${resp.status} please try again`);
			// 					setShowLoader(false);
			// 				}
			// 			}
			// 		},
			// 		(err: any) => {
			// 			showAlert(`Error: ${err}`, { type: 'error' });
			// 			setShowLoader(false);
			// 		}
			// 	);
		} else {
			showAlert('Please test this CSV on dev environment first', { type: 'warning' });
			setShowLoader(false);
		}
	};

	const getQuestionBankDevStatus = (data: any) => {
		setShowLoader(true);
		const questionBankLogKey: string = `questionBankDevLog-${data.gameName}`;
		const questionBankDevLogFromLocal: string | null = window.localStorage.getItem(questionBankLogKey);
		const questionBankDevLog = questionBankDevLogFromLocal ? JSON.parse(questionBankDevLogFromLocal as string) : null;
		if (!questionBankDevLog) {
			showAlert('No deployment found');
			setShowLoader(false);
		} else if (questionBankDevLog.status === 'SUCCESS') {
			showAlert('Deployment succeded, please go ahead for prod deployment');
			setShowLoader(false);
		} else {
			getQuestionBankCsvStatus(
				{ app },
				{ docId: questionBankDevLog.docId, environment: QUESTION_BANK_ENVIRONMENT.STAGING }
			).then(
				(res: any) => {
					if (res?.status !== 200 || !res?.data?.success) {
						showAlert(res?.data?.error || 'Error while checking dev questionBank status', { type: 'error' });
						setShowLoader(false);
					} else {
						const resp = res?.data?.data;
						window.localStorage.setItem(questionBankLogKey, JSON.stringify({ status: resp.status, docId: resp.docId }));
						if (resp.status === 'SUCCESS') {
							showAlert('Deployment succeded, please go ahead for prod deployment');
							setShowLoader(false);
						} else {
							showAlert(`Dev test status: ${resp.status} please try again`);
							setShowLoader(false);
							setStatusLogsState(resp?.logs?.steps ? resp?.logs?.steps.join('<br>') : '');
						}
					}
				},
				(err: any) => {
					showAlert(`Error: ${err}`, { type: 'error' });
					setShowLoader(false);
				}
			);
		}
	};

	// const csvDiff = (data: any) => {
	// 	setShowLoader(true);
	// 	requestCsvDiff(app.appName, { ...data }).then(
	// 		(res: any) => {
	// 			if (res?.status !== 200 || !res?.data?.success) {
	// 				showAlert(res?.data?.error || 'Error occured while getting diff', { type: 'error' });
	// 				setShowLoader(false);
	// 			} else {
	// 				showAlert('Csv Diff loaded');
	// 				setShowLoader(false);
	// 				setCsvDiffValue(res?.data?.data || emptyCsvObject);
	// 			}
	// 		},
	// 		(err: any) => {
	// 			showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
	// 			setShowLoader(false);
	// 		}
	// 	);
	// };

	const handleFormSubmit = (submittedData: any) => {
		createQuestionBank(submittedData);
	};

	// const handleCsvDiff = (submittedData: any) => {
	// 	setIsDiffClose(false);
	// 	setCsvDiffValue(emptyCsvObject);
	// 	csvDiff(submittedData);
	// };

	const handleQuestionBankStatusSubmit = (submittedData: any) => {
		getQuestionBankDevStatus(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	// const handleDiffDivClose = () => {
	// 	setIsDiffClose(true);
	// };

	// const handleOpenDiffForm = () => {
	// 	setDiffFormState(true);
	// 	setUploadFormState(false);
	// 	setStatusFormState(false);
	// 	setStatusLogsState('');
	// };

	const handleUploadForm = () => {
		// setDiffFormState(false);
		setUploadFormState(true);
		setStatusFormState(false);
		// setIsDiffClose(true);
		setStatusLogsState('');
	};

	const handleStatusForm = () => {
		// setDiffFormState(false);
		setUploadFormState(false);
		setStatusFormState(true);
		// setIsDiffClose(true);
		setStatusLogsState('');
	};

	return {
		data: EMPTY_OBJECT,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader,
		// handleCsvDiff,
		// csvDiffValue,
		// handleDiffDivClose,
		// isDiffClose,
		// handleOpenDiffForm,
		handleUploadForm,
		handleStatusForm,
		// diffFormState,
		uploadFormState,
		statusFormState,
		statusLogs,
		handleQuestionBankStatusSubmit
	};
};

export default useCreate;
